import { TagValue } from 'framework/components/ui/Tag/interfaces';

export const ORDER_IN_MODIFICATION = {
  captionKey: 'generic.status.orderInModification',
  ofCaptionKey: 'modules.orderFulfillment.pickingStatus.modificationSession',
  warningKey: 'generic.status.orderInModificationWarning',
  tagValue: TagValue['modification-session'],
  cssStatus: 'modificationSession',
} as const;

export const isOrderInModification = (
  isFlagOn: boolean,
  activeModificationSession?: boolean
): boolean => isFlagOn && activeModificationSession === true;
